import React, { Fragment, useState, useEffect } from 'react'
import { Routes, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import CircularProgress from '@mui/material/CircularProgress';
import Container from 'react-bootstrap/Container';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Home from '../../pages/Home';
import Tasks from '../../pages/Tasks';
import Tasks2 from '../../pages/Tasks/t2';
import Task from '../../pages/Tasks/Task';
import Calls from '../../pages/Tasks/Calls';
import Lists from '../../pages/Lists';
import List from '../../pages/Lists/List';
import Events from '../../pages/Events';
import Event from '../../pages/Events/Event';
import Reviews from '../../pages/Reviews';
import Review from '../../pages/Reviews/Review';
import Leads from '../../pages/Contacts/Leads';
import AllOpps from '../../pages/Contacts/AllOpps';
import Nurtures from '../../pages/Contacts/Nurtures'
import LoansAppSent from '../../pages/Loans/PAApps';
import LoansSetup from '../../pages/Loans/PASetup';
import LoansReviews from '../../pages/Loans/PAReviews';
import LoansPreApproved from '../../pages/Loans/PreApprovals';
import LoansPreQual from '../../pages/Loans/PreQuals';
import LoansRefiWaiting from '../../pages/Loans/RefiWaiting';
import LoansActive from '../../pages/Loans/Active';
import LoansConstruction from '../../pages/Loans/Construction';
import LoansLost from '../../pages/Loans/Lost';
import LoansClosed from '../../pages/Loans/Closed';
import BizPartners from '../../pages/Contacts/BizPartners';
import Realtors from '../../pages/Contacts/Realtors';
import OtherPartners from '../../pages/Contacts/OtherPartners';
import Borrowers from '../../pages/Contacts/Borrowers';
import Associates from '../../pages/Contacts/Associates';
import Reports from '../../pages/Reports';
import ReportsV2 from '../../pages/Reports/v2';
import ReportsDashboard from '../../pages/Reports/dashboard';
import Users from '../../pages/Users';
import User from '../../pages/Users/User';
import Marketing from '../../pages/Marketing';
import Contact from '../../pages/Contacts/Contact';
import Login from '../../pages/Login';
import Stack from '../../pages/Stack';
import Outlook from '../../pages/Outlook';
import Loan from '../../pages/Loans/Loan';
import LeadOpp from '../../pages/LeadOpps/LeadOpp';
import Gift from '../../pages/Gifts/Gift';
import Note from '../../pages/Notes/Note';
import Offer from '../../pages/Offers/Offer';
import OAuth from '../../pages/OAuth';
import Playbooks from '../../pages/Playbooks';
import PlaybooksV2 from '../../pages/Playbooks/v2';
import Playbook from '../../pages/Playbooks/Playbook';
import Inbox from '../../pages/Inbox';
import DoneIcon from '@mui/icons-material/Done';
import Nylas from '../../pages/OAuth/nylas';
import Prospects from '../../pages/Loans/Prospects';
import Messages from '../../pages/Messages';
import Automations from '../../pages/Automations';


const Body = ( { user, restore, loadContacts, loadLoans, loadLeadOpps, loadTasks, loadLists, loadEvents, loadGifts, loadNotes, loadReviews, loadGameplan, loadComms, loadMessages, loadFiles, loadRefsOut, loadOffers, loadPlaybooks, loadTemplates, loadUsers } ) => {
    const [ cookies, setCookie, removeCookie ] = useCookies( [ 'tfu', 'tfs' ] );
    const [ restoring, setRestoring ] = useState( true );
    const [ blueScreen, setBlueScreen ] = useState( false );

    const [ loadData, setLoadData ] = useState( false );
    const [ loadInProcess, setLoadInProcess ] = useState( false );
    const [ loadFinished, setLoadFinished ] = useState( false );
    const [ showLoad, setShowLoad ] = useState( false );
    
    const [ contactsLoaded, setContactsLoaded ] = useState( false );
    const [ loansLoaded, setLoansLoaded ] = useState( false );
    const [ tasksLoaded, setTasksLoaded ] = useState( false );
    const [ notesLoaded, setNotesLoaded ] = useState( false );
    const [ reviewsLoaded, setReviewsLoaded ] = useState( false );
    const [ eventsLoaded, setEventsLoaded ] = useState( false );
    const [ oppsLoaded, setOppsLoaded ] = useState( false );
    const [ listsLoaded, setListsLoaded ] = useState( false );
    const [ giftsLoaded, setGiftsLoaded ] = useState( false );
    const [ gameplanLoaded, setGameplanLoaded ] = useState( false );

    const resetLoadedData = () => {
        setContactsLoaded( false );
        setLoansLoaded( false );
        setTasksLoaded( false );
        setNotesLoaded( false );
        setReviewsLoaded( false );
        setEventsLoaded( false );
        setOppsLoaded( false );
        setListsLoaded( false );
        setGiftsLoaded( false );
        setGameplanLoaded( false );
        setLoadFinished( false );
    }

    useEffect( () => {
        async function attemptRestore() {
            if ( cookies.tfs && cookies.tfs.length ) {
                console.log( 'try to restore session:',  cookies );
                await restore( { uid: cookies.tfu, sid: cookies.tfs } );
            } else {
                console.log( 'no cookies - must login' );
            }
            setRestoring( false );
        }

        // load only finishes after successul login
        // if no password, implies a logout and we don't
        // want to auto restore
        if ( !loadFinished && !user.password ) {
            console.log( 'calling attemptRestore' );
            attemptRestore();
        }

        return ( () => {
        } );
    }, [ cookies, restore, user.password, loadFinished ] );

    useEffect( () => {
        if ( !restoring && user.password ) {
            resetLoadedData();
            console.log( 'has pwd - loading data' );
            setLoadData( true );
        } else if ( !restoring ) {
            console.log( 'removing session cookie' );
            removeCookie( 'tfs', { path: '/' } );
        }
    }, [ user.password, removeCookie, restoring ] );

    useEffect( () => {
        if ( user.email && user.email.length ) {
            console.log( 'setting user cookie' );
            setCookie( 'tfu', user.email, { secure: true, path: '/', sameSite: 'strict' } );
        }
        if ( user.sid && user.sid.length ) {
            console.log( 'setting session cookie' );
            setCookie( 'tfs', user.sid, { secure: true, path: '/', sameSite: 'strict' } );
        }
    }, [ user.email, user.sid, setCookie ] );

    useEffect( () => {
        if ( user.role === 'bluescreen' ) {
            console.log( 'Setting blue screen of death for: ', user );
            setBlueScreen( true );
        } else {
            setBlueScreen( false );
        }
       console.log( 'user: ', user );
    }, [ user ] );

    useEffect( () => {
        const load = async ( oid, aid, seg, getBorrowers, getPartners, getAssociates ) => {
            if ( getBorrowers ) {
                await loadContacts( { orgId: oid, aid: aid, uid: user.email, segment: `${seg}-borrowers` } );
            }
            if ( getPartners ) {
                await loadContacts( { orgId: oid, aid: aid, uid: user.email, segment: `${seg}-partners` } );
            }
            if ( getAssociates ) {
                await loadContacts( { orgId: oid, aid: aid, uid: user.email, segment: `${seg}-associates` } );
            }
            setContactsLoaded( true );
        }
        if ( loadData && !loadInProcess ) {
            let getOrgBorrowers = false;
            let getOrgPartners = false;
            let getOrgAssociates = false;

            if ( user.org ) {
                console.log( 'org: ', user.org );
                getOrgBorrowers = user.org.shareBorrowers;
                getOrgPartners = user.org.sharePartners;
                getOrgAssociates = user.org.shareAssociates;
            }

            if ( user.additionalAccounts ) {
                console.log( 'addl: ', user.additionalAccounts );
                
                if ( !getOrgBorrowers && !getOrgPartners && !getOrgAssociates ) {
                    console.log( 'no org sharing - standard contact load' );
                    user.additionalAccounts.forEach( a => {
                        console.log( 'pulling contacts for: ' + a.aid );
                        load( user.orgId, a.aid, 'all', true, true, user.canViewAssociates );
                    } );
                } else {
                    console.log( `Pulling org for partners (${getOrgPartners}) borrowers (${getOrgBorrowers}) associates (${getOrgAssociates})` );
                    load( user.orgId, user.aid, 'org', getOrgBorrowers, getOrgPartners, ( getOrgAssociates ) ? user.canViewAssociates : false );

                    user.additionalAccounts.forEach( a => {
                        console.log( 'pulling contacts for: ' + a.aid );
                        load( user.orgId, a.aid, 'all', !getOrgBorrowers, !getOrgPartners, ( !getOrgAssociates ) ? user.canViewAssociates : false );
                    } );
                }
            } else {
                if ( !getOrgBorrowers && !getOrgPartners && !getOrgAssociates ) {
                    console.log( 'no org sharing - standard contact load' );
                    load( user.orgId, user.aid, 'all', true, true, user.canViewAssociates );    
                } else {
                    console.log( `Pulling org for partners (${getOrgPartners}) borrowers (${getOrgBorrowers}) associates (${getOrgAssociates})` );
                    load( user.orgId, user.aid, 'org', getOrgBorrowers, getOrgPartners, ( getOrgAssociates ) ? user.canViewAssociates : false );
                    load( user.orgId, user.aid, 'all', !getOrgBorrowers, !getOrgPartners, ( !getOrgAssociates ) ? user.canViewAssociates : false );
                }
            }
        }
    }, [ user.orgId, user.aid, user.email, user.additionalAccounts, user.canViewAssociates, user.org, loadContacts, loadData, loadInProcess ] );

    useEffect( () => {
        const load = async ( aid ) => {
            await loadLoans( { aid: aid, uid: user.email } );
            setLoansLoaded( true );
        }
        if ( loadData && !loadInProcess ) {
            if ( user.additionalAccounts ) {
                user.additionalAccounts.forEach( a => {
                    load( a.aid );
                } );
            } else {
                load( user.aid );
            }
        }
    }, [ user.aid, user.email, user.additionalAccounts, loadLoans, loadData, loadInProcess ] );

    useEffect( () => {
        const load = async ( aid ) => {
            await loadTasks( { aid: aid, uid: user.email } );
            setTasksLoaded( true );
        }
        if ( loadData && !loadInProcess ) {
            if ( user.additionalAccounts ) {
                user.additionalAccounts.forEach( a => {
                    load( a.aid );
                } );
            } else {
                load( user.aid );
            }
        }
    }, [ user.aid, user.email, user.additionalAccounts, loadTasks, loadData, loadInProcess ] );

    useEffect( () => {
        const load = async ( aid ) => {
            await loadNotes( { aid: aid, uid: user.email } );
            setNotesLoaded( true );
        }
        if ( loadData && !loadInProcess ) {
            if ( user.additionalAccounts ) {
                user.additionalAccounts.forEach( a => {
                    load( a.aid );
                } );
            } else {
                load( user.aid );
            }
        }
    }, [ user.aid, user.email, user.additionalAccounts, loadNotes, loadData, loadInProcess ] );

    useEffect( () => {
        const load = async ( aid ) => {
            await loadReviews( { aid: aid, uid: user.email } );
            setReviewsLoaded( true );
        }
        if ( loadData && !loadInProcess ) {
            if ( user.additionalAccounts ) {
                user.additionalAccounts.forEach( a => {
                    load( a.aid );
                } );
            } else {
                load( user.aid );
            }
        }
    }, [ user.aid, user.email, user.additionalAccounts, loadReviews, loadData, loadInProcess ] );

    useEffect( () => {
        const load = async ( aid ) => {
            await loadEvents( { aid: aid, uid: user.email } );
            setEventsLoaded( true );
        }
        if ( loadData && !loadInProcess ) {
            if ( user.additionalAccounts ) {
                user.additionalAccounts.forEach( a => {
                    load( a.aid );
                } );
            } else {
                load( user.aid );
            }
        }
    }, [ user.aid, user.email, user.additionalAccounts, loadEvents, loadData, loadInProcess ] );

    useEffect( () => {
        const load = async ( aid ) => {
            await loadLeadOpps( { aid: aid, uid: user.email } );
            setOppsLoaded( true );
        }
        if ( loadData && !loadInProcess ) {
            if ( user.additionalAccounts ) {
                user.additionalAccounts.forEach( a => {
                    load( a.aid );
                } );
            } else {
                load( user.aid );
            }
        }
    }, [ user.aid, user.email, user.additionalAccounts, loadLeadOpps, loadData, loadInProcess ] );

    useEffect( () => {
        const load = async ( aid ) => {
            await loadLists( { aid: aid, uid: user.email } );
            setListsLoaded( true );
        }
        if ( loadData && !loadInProcess ) {
            if ( user.additionalAccounts ) {
                user.additionalAccounts.forEach( a => {
                    load( a.aid );
                } );
            } else {
                load( user.aid );
            }
        }
    }, [ user.aid, user.email, user.additionalAccounts, loadLists, loadData, loadInProcess ] );

    useEffect( () => {
        const load = async ( aid ) => {
            await loadGifts( { aid: aid, uid: user.email } );
            setGiftsLoaded( true );
        }
        if ( loadData && !loadInProcess ) {
            if ( user.additionalAccounts ) {
                user.additionalAccounts.forEach( a => {
                    load( a.aid );
                } );
            } else {
                load( user.aid );
            }
        }
    }, [ user.aid, user.email, user.additionalAccounts, loadGifts, loadData, loadInProcess ] );

    useEffect( () => {
        const load = async ( aid ) => {
            await loadGameplan( { aid: aid, uid: user.email } );
            setGameplanLoaded( true );
        }
        if ( loadData && !loadInProcess ) {
            if ( user.additionalAccounts ) {
                user.additionalAccounts.forEach( a => {
                    load( a.aid );
                } );
            } else {
                load( user.aid );
            }
        }
    }, [ user.aid, user.email, user.additionalAccounts, loadGameplan, loadData, loadInProcess ] );

    // Comms ... we're not tracking if this completes
    useEffect( () => {
        const load = async ( aid ) => {
            await loadComms( { aid: aid, uid: user.email, channel: 'sms' } );
            await loadComms( { aid: aid, uid: user.email, channel: 'email' } );
            await loadComms( { aid: aid, uid: user.email, channel: 'call' } );
        }
        if ( loadData && !loadInProcess ) {
            if ( user.additionalAccounts ) {
                user.additionalAccounts.forEach( a => {
                    load( a.aid );
                } );
            } else {
                load( user.aid );
            }
        }
    }, [ user.aid, user.email, user.additionalAccounts, loadComms, loadData, loadInProcess ] );

    // Messages ... we're not tracking if this completes
    useEffect( () => {
        const load = async ( aid ) => {
            await loadMessages( { aid: aid, uid: user.email } );
        }
        if ( loadData && !loadInProcess ) {
            if ( user.additionalAccounts ) {
                user.additionalAccounts.forEach( a => {
                    load( a.aid );
                } );
            } else {
                load( user.aid );
            }
        }
    }, [ user.aid, user.email, user.additionalAccounts, loadMessages, loadData, loadInProcess ] );

    // Files ... we're not tracking if this completes
    useEffect( () => {
        const load = async ( aid ) => {
            await loadFiles( { aid: aid, uid: user.email } );
        }
        if ( loadData && !loadInProcess ) {
            if ( user.additionalAccounts ) {
                user.additionalAccounts.forEach( a => {
                    load( a.aid );
                } );
            } else {
                load( user.aid );
            }
        }
    }, [ user.aid, user.email, user.additionalAccounts, loadFiles, loadData, loadInProcess ] );

    // RefsOut ... we're not tracking if this completes
    useEffect( () => {
        const load = async ( aid ) => {
            await loadRefsOut( { aid: aid, uid: user.email } );
        }
        if ( loadData && !loadInProcess ) {
            if ( user.additionalAccounts ) {
                user.additionalAccounts.forEach( a => {
                    load( a.aid );
                } );
            } else {
                load( user.aid );
            }
        }
    }, [ user.aid, user.email, user.additionalAccounts, loadRefsOut, loadData, loadInProcess ] );

    // Offers ... we're not tracking if this completes
    useEffect( () => {
        const load = async ( aid ) => {
            await loadOffers( { aid: aid, uid: user.email } );
        }
        if ( loadData && !loadInProcess ) {
            if ( user.additionalAccounts ) {
                user.additionalAccounts.forEach( a => {
                    load( a.aid );
                } );
            } else {
                load( user.aid );
            }
        }
    }, [ user.aid, user.email, user.additionalAccounts, loadOffers, loadData, loadInProcess ] );

    // Playbooks ... we're not tracking if this completes
    useEffect( () => {
        console.log( 'inside playbook hook...' );
        const load = async ( aid ) => {
            console.log( 'loading playbooks...' );
            await loadPlaybooks( { aid: aid, uid: user.email } );
            console.log( 'finished loading playbooks...' );
        }
        if ( loadData && !loadInProcess ) {
            console.log( 'about to load playbooks...' );
            if ( user.additionalAccounts ) {
                user.additionalAccounts.forEach( a => {
                    load( a.aid );
                } );
            } else {
                load( user.aid );
            }
        }
    }, [ user.aid, user.email, user.additionalAccounts, loadPlaybooks, loadData, loadInProcess ] );

    // Templates ... we're not tracking if this completes
    useEffect( () => {
        const load = async ( aid ) => {
            await loadTemplates( { aid: aid, uid: user.email } );
        }
        if ( loadData && !loadInProcess ) {
            if ( user.additionalAccounts ) {
                user.additionalAccounts.forEach( a => {
                    load( a.aid );
                } );
            } else {
                load( user.aid );
            }
        }
    }, [ user.aid, user.email, user.additionalAccounts, loadTemplates, loadData, loadInProcess ] );

    // Admin Users ... we're not tracking if this completes
    useEffect( () => {
        const load = async ( orgId, aid ) => {
            await loadUsers( { orgId: orgId, aid: aid, uid: user.email } );
        }
        if ( loadData && !loadInProcess ) {
            if ( user.org && user.role === 'org-admin' ) {
                console.log( 'Loading admin users!' );
                load( user.org.oid, user.aid );
            }
        }
    }, [ user.org, user.aid, user.email, user.role, loadUsers, loadData, loadInProcess ] );

    useEffect( () => {
        if ( loadData && !loadInProcess ) {
            setShowLoad( true );
            setLoadInProcess( true );
        }
    }, [ loadInProcess, loadData ] );

    useEffect( () => {
        if ( contactsLoaded && loansLoaded && tasksLoaded && notesLoaded && reviewsLoaded && eventsLoaded && oppsLoaded && listsLoaded && giftsLoaded && gameplanLoaded ) {
            setLoadData( false );
            setShowLoad( false );
            setLoadInProcess( false );
            setLoadFinished( true );
        }
    }, [ contactsLoaded, loansLoaded, tasksLoaded, notesLoaded, reviewsLoaded, eventsLoaded, oppsLoaded, listsLoaded, giftsLoaded, gameplanLoaded ] );

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '350px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    return (
        restoring ? (
            <Container fluid className='p-1'>
                <CircularProgress />
            </Container>
        ) : !user.password ? (
            <Login />
        ) : loadData ? (
            <Modal open={showLoad} onClose={ ( e, r ) => { if ( r !== 'backdropClick' ) { setShowLoad( false ); } } }>
                <Fragment>
                    <Box sx={ { ...style } }>
                        <Container fluid>
                            <Row>
                                <Col className='text-center tf-dataload-title'>
                                    Hang on a moment while we load you up...
                                </Col>
                            </Row>
                            <Row className='pt-2'>
                                <Col>
                                    <Row className='align-items-center'>
                                        <Col xs='auto' className='p-0 tf-dataload-obj'>Contacts: </Col>
                                        <Col className='ps-1 tf-dataload-icon'>
                                            {
                                                ( contactsLoaded ) ? (
                                                    <DoneIcon />
                                                ) : (
                                                    <CircularProgress size='20px' />
                                                )
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row className='align-items-center'>
                                        <Col xs='auto' className='p-0 tf-dataload-obj'>Events: </Col>
                                        <Col className='ps-1 tf-dataload-icon'>
                                            {
                                                ( eventsLoaded ) ? (
                                                    <DoneIcon />
                                                ) : (
                                                    <CircularProgress size='20px' />
                                                )
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className='pt-2'>
                                <Col>
                                    <Row className='align-items-center'>
                                        <Col xs='auto' className='p-0 tf-dataload-obj'>Loans: </Col>
                                        <Col className='ps-1 tf-dataload-icon'>
                                            {
                                                ( loansLoaded ) ? (
                                                    <DoneIcon />
                                                ) : (
                                                    <CircularProgress size='20px' />
                                                )
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row className='align-items-center'>
                                        <Col xs='auto' className='p-0 tf-dataload-obj'>Lead Opps: </Col>
                                        <Col className='ps-1 tf-dataload-icon'>
                                            {
                                                ( oppsLoaded ) ? (
                                                    <DoneIcon />
                                                ) : (
                                                    <CircularProgress size='20px' />
                                                )
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className='pt-2'>
                                <Col>
                                    <Row className='align-items-center'>
                                        <Col xs='auto' className='p-0 tf-dataload-obj'>Tasks: </Col>
                                        <Col className='ps-1 tf-dataload-icon'>
                                            {
                                                ( tasksLoaded ) ? (
                                                    <DoneIcon />
                                                ) : (
                                                    <CircularProgress size='20px' />
                                                )
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row className='align-items-center'>
                                        <Col xs='auto' className='p-0 tf-dataload-obj'>Lists: </Col>
                                        <Col className='ps-1 tf-dataload-icon'>
                                            {
                                                ( listsLoaded ) ? (
                                                    <DoneIcon />
                                                ) : (
                                                    <CircularProgress size='20px' />
                                                )
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className='pt-2'>
                                <Col>
                                    <Row className='align-items-center'>
                                        <Col xs='auto' className='p-0 tf-dataload-obj'>Notes: </Col>
                                        <Col className='ps-1 tf-dataload-icon'>
                                            {
                                                ( notesLoaded ) ? (
                                                    <DoneIcon />
                                                ) : (
                                                    <CircularProgress size='20px' />
                                                )
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row className='align-items-center'>
                                        <Col xs='auto' className='p-0 tf-dataload-obj'>Gifts: </Col>
                                        <Col className='ps-1 tf-dataload-icon'>
                                            {
                                                ( giftsLoaded ) ? (
                                                    <DoneIcon />
                                                ) : (
                                                    <CircularProgress size='20px' />
                                                )
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className='pt-2'>
                                <Col>
                                    <Row className='align-items-center'>
                                        <Col xs='auto' className='p-0 tf-dataload-obj'>Reviews: </Col>
                                        <Col className='ps-1 tf-dataload-icon'>
                                            {
                                                ( reviewsLoaded ) ? (
                                                    <DoneIcon />
                                                ) : (
                                                    <CircularProgress size='20px' />
                                                )
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row className='align-items-center'>
                                        <Col xs='auto' className='p-0 tf-dataload-obj'>Gameplan: </Col>
                                        <Col className='ps-1 tf-dataload-icon'>
                                            {
                                                ( gameplanLoaded ) ? (
                                                    <DoneIcon />
                                                ) : (
                                                    <CircularProgress size='20px' />
                                                )
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    </Box>
                </Fragment>
            </Modal>    
        ) : blueScreen ? (
            <Container fluid className='p-1'>
                <Row style={ { height: '100vh' } }>

                </Row>
            </Container>    
        ): (
            <Fragment>
                <Routes>
                    <Route path="/" element={ <Home /> } />
                    <Route path="/tasks" element={ <Tasks /> } />
                    <Route path="/t2" element={ <Tasks2 /> } />
                    <Route path="/task/:tid" element={ <Task /> } />
                    <Route path="/calls" element={ <Calls /> } />
                    <Route path="/lists" element={ <Lists /> } />
                    <Route path="/list/:gid" element={ <List /> } />
                    <Route path="/events" element={ <Events /> } />
                    <Route path="/event/:eid" element={ <Event /> } />
                    <Route path="/reviews" element={ <Reviews /> } />
                    <Route path="/review/:rid" element={ <Review /> } />
                    <Route path="/leads" element={ <Leads /> } />
                    <Route path="/leads/:status" element={ <Leads /> } />
                    <Route path="/all-leads" element={ <AllOpps /> } />
                    <Route path="/nurtures" element={ <Nurtures /> } />
                    <Route path="/prospects" element={ <Prospects /> } />
                    <Route path="/apps-sent" element={ <LoansAppSent /> } />
                    <Route path="/pa-setup" element={ <LoansSetup /> } />
                    <Route path="/pa-reviews" element={ <LoansReviews /> } />
                    <Route path="/pre-approvals" element={ <LoansPreApproved /> } />
                    <Route path="/pre-quals" element={ <LoansPreQual /> } />
                    <Route path="/refi-waiting" element={ <LoansRefiWaiting /> } />
                    <Route path="/loans-active" element={ <LoansActive /> } />
                    <Route path="/loans-const" element={ <LoansConstruction /> } />
                    <Route path="/loans-lost" element={ <LoansLost /> } />
                    <Route path="/loans-closed" element={ <LoansClosed /> } />
                    <Route path="/borrowers" element={ <Borrowers /> } />
                    <Route path="/biz-partners" element={ <BizPartners /> } />
                    <Route path="/realtors" element={ <Realtors /> } />
                    <Route path="/other-partners" element={ <OtherPartners /> } />
                    <Route path="/associates" element={ <Associates /> } />
                    <Route path="/reports" element={ <Reports /> } />
                    <Route path="/insights" element={ <ReportsV2 /> } />
                    <Route path="/insights/:rid" element={ <ReportsV2 /> } />
                    <Route path="/reporting" element={ <ReportsDashboard /> } />
                    <Route path="/marketing" element={ <Marketing /> } />
                    <Route path="/contact/:cid" element={ <Contact /> } />
                    <Route path="/loan/:lid" element={ <Loan /> } />
                    <Route path="/lead-opp/:loid" element={ <LeadOpp /> } />
                    <Route path="/gift/:gid" element={ <Gift /> } />
                    <Route path="/note/:nid" element={ <Note /> } />
                    <Route path="/offer/:oid" element={ <Offer /> } />
                    <Route path="/stack" element={ <Stack /> } />
                    <Route path="/outlook" element={ <Outlook /> } />
                    <Route path="/oauth" element={ <OAuth /> } />
                    <Route path="/oauth/exchange" element={ <Nylas /> } />
                    <Route path="/playbooks" element={ <Playbooks /> } />
                    <Route path="/playbooks2" element={ <PlaybooksV2 /> } />
                    <Route path="/playbook/:pid" element={ <Playbook /> } />
                    <Route path="/inbox" element={ <Inbox /> } />
                    <Route path="/inbox/:cid" element={ <Inbox /> } />
                    <Route path="/users" element={ <Users /> } />
                    <Route path="/user/:uid" element={ <User /> } />
                    <Route path="/messages" element={ <Messages /> } />
                    <Route path="/automations" element={ <Automations /> } />
                </Routes>
            </Fragment>
        )
    )
}

const mapProps = ( state ) =>( {
    user: state.user
} );

const mapDispatch = ( dispatch ) => ( {
    restore: dispatch.user.restoreSession,
    loadContacts: dispatch.contacts.loadContacts,
    loadLoans: dispatch.loans.loadLoans,
    loadLeadOpps: dispatch.leadopps.loadLeadOpps,
    loadTasks: dispatch.tasks.loadTasks,
    loadLists: dispatch.lists.loadLists,
    loadEvents: dispatch.events.loadEvents,
    loadGifts: dispatch.gifts.loadGifts,
    loadNotes: dispatch.notes.loadNotes,
    loadReviews: dispatch.reviews.loadReviews,
    loadGameplan: dispatch.gameplan.loadGameplan,
    loadComms: dispatch.comms.loadComms,
    loadMessages: dispatch.messages.loadMessages,
    loadFiles: dispatch.files.loadFiles,
    loadRefsOut: dispatch.referredout.loadRefsOut,
    loadOffers: dispatch.offers.loadOffers,
    loadPlaybooks: dispatch.playbooks.loadPlaybooks,
    loadTemplates: dispatch.templates.loadTemplates,
    loadUsers: dispatch.admin.loadUsers
} );

export default connect( mapProps, mapDispatch )( Body );